export const QUERY_KEYS = {
  PROFILE: ['profile'],
  STORES: ['stores'],
  STORE_INFO: (id: string) => ['store-info', id] as const,
  TENANT_OVERVIEW: (from: number, to: number) => ['tenant-overview', from, to] as const,
  STORE_OVERVIEW: (id: string, from: number, to: number) => ['store-overview', id, from, to] as const,
  STORE_INFO_WITH_CUTOFF: (id: string) => ['store-info-with-cutoff', id] as const,
  AUDIT_LOG: (page: number) => ['audit-log', page] as const,
  PLANS: ['plans'],
} as const;

// P2-6 (constitution 2026-06-09): per-screen query-key factory for the
// anomaly module. List filters fold into a single object so the keys are
// stable across re-renders and `queryClient.invalidateQueries({ queryKey:
// ['anomalies', 'list', storeId] })` invalidates every paged/filtered
// variant after a review mutation.
export const anomalyKeys = {
  all: (storeId: string) => ['anomalies', storeId] as const,
  list: (
    storeId: string,
    filters: {
      fromDate: string;
      toDate: string;
      entityType: string;
      severityMin: string;
      operatorFilter: string;
      reviewStatus: string;
      page: number;
    },
  ) => ['anomalies', 'list', storeId, filters] as const,
  listAll: (storeId: string) => ['anomalies', 'list', storeId] as const,
  summary: (storeId: string, fromDate: string, toDate: string) =>
    ['anomalies', 'summary', storeId, fromDate, toDate] as const,
  summaryAll: (storeId: string) => ['anomalies', 'summary', storeId] as const,
  sparkline: (storeId: string, fromDate: string, toDate: string) =>
    ['anomalies', 'sparkline', storeId, fromDate, toDate] as const,
  detail: (storeId: string, anomalyId: string) =>
    ['anomalies', 'detail', storeId, anomalyId] as const,
  detailAll: (storeId: string) => ['anomalies', 'detail', storeId] as const,
};
